import React from 'react';
import { connect } from 'react-redux';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import EditCourse from './editCourse'
import LeftMenu from '../AppLayout/leftMenu'  

function MyCourse(props){
    return (
    <React.Fragment>
      <CssBaseline />
      <Container maxWidth="md">
        <Grid item style={{ maxWidth: '14%', flexBasis: '14%' }}>
          <LeftMenu history={props.history} />
        </Grid>
      </Container>
      <div>
        <Grid>
          <EditCourse match={props.match} history={props.history} />
        </Grid>
      </div>
    </React.Fragment>
    );
}

const mapStateToProps = state => {
  return {}
}

export default connect(
  mapStateToProps, {}
)(MyCourse);